import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { AMBLogo } from "./AMBLogo";
import { WhatsAppIcon } from "./icons";
import { NAV_LINKS, WHATSAPP_URL } from "../data/site";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled || open
          ? "bg-[#0B0F14]/85 backdrop-blur-md border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10 xl:max-w-none xl:px-[5vw]">
        <a href="#hero" data-testid="nav-logo-link" aria-label="AMB Solutions — início">
          <AMBLogo />
        </a>
        <nav className="hidden items-center gap-9 md:flex" aria-label="Navegação principal">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace("ó", "o")}`}
              className="text-xs font-medium uppercase tracking-[0.2em] text-slate-400 transition-colors duration-300 hover:text-white"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-cta"
            className="group inline-flex items-center gap-2 rounded-full bg-[#007BFF] px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.14em] text-white transition-shadow duration-300 hover:shadow-[0_0_28px_rgba(0,123,255,0.55)]"
          >
            <WhatsAppIcon className="h-4 w-4 transition-transform duration-300 group-hover:scale-110" />
            WhatsApp
          </a>
        </nav>
        <button
          className="text-slate-200 md:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="flex flex-col gap-1 border-t border-white/5 px-6 pb-6 pt-3 md:hidden" data-testid="nav-mobile-menu">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${link.label.toLowerCase().replace("ó", "o")}`}
              className="py-3 text-sm font-medium uppercase tracking-[0.2em] text-slate-300"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-mobile-whatsapp-cta"
            className="mt-3 inline-flex items-center justify-center gap-2 rounded-full bg-[#007BFF] px-5 py-3 text-sm font-semibold text-white"
          >
            <WhatsAppIcon className="h-4 w-4" />
            Falar no WhatsApp
          </a>
        </nav>
      )}
    </header>
  );
};
